import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { getIconStyles as c } from "../styles.js";
const r = (e) => /* @__PURE__ */ i(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: c(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_3928_22221)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.13348 9.27849C-0.367411 10.7794 -0.367411 13.2128 1.13348 14.7137L9.2863 22.8665C10.7872 24.3674 13.2206 24.3674 14.7215 22.8665L22.8743 14.7137C24.3752 13.2128 24.3752 10.7794 22.8743 9.27849L14.7215 1.12567C13.2206 -0.375223 10.7872 -0.375223 9.2863 1.12567L1.13348 9.27849ZM12 17.9961C15.3137 17.9961 18 15.3098 18 11.9961C18 8.68239 15.3137 5.99609 12 5.99609C8.68629 5.99609 6 8.68239 6 11.9961C6 15.3098 8.68629 17.9961 12 17.9961ZM9.79009 11.3238C9.49719 11.0309 9.02232 11.0309 8.72943 11.3238C8.43653 11.6167 8.43653 12.0915 8.72943 12.3844L10.7125 14.3675C11.0054 14.6604 11.4803 14.6604 11.7732 14.3675L15.2784 10.8626C15.5713 10.5697 15.5713 10.0948 15.2784 9.80191C14.9855 9.50902 14.5106 9.50902 14.2177 9.80191L11.243 12.7767L9.79009 11.3238Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3928_22221", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  r as DiamondCheckIcon
};
//# sourceMappingURL=DiamondCheckIcon.js.map
